/* tslint:disable */
/* eslint-disable */
//----------------------
// <auto-generated>
//     Generated using the NSwag toolchain v12.3.1.0 (NJsonSchema v9.14.1.0 (Newtonsoft.Json v11.0.0.0)) (http://NSwag.org)
// </auto-generated>
//----------------------
// ReSharper disable InconsistentNaming

import { mergeMap as _observableMergeMap, catchError as _observableCatch } from 'rxjs/operators';
import { Observable, throwError as _observableThrow, of as _observableOf } from 'rxjs';
import { Injectable, Inject, Optional, InjectionToken } from '@angular/core';
import { HttpClient, HttpHeaders, HttpResponse, HttpResponseBase } from '@angular/common/http';

import * as moment from 'moment';

export const TASK_API_BASE_URL = new InjectionToken<string>('TASK_API_BASE_URL');

@Injectable()
export class TaskServiceProxy {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = (key: string, value: any) => key ? value : value.result || value;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(TASK_API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl ? baseUrl : "/";
    }

    /**
     * Stops Message Queue Listeners
     * @return Success
     */
    stopListeners(): Observable<void> {
        let url_ = this.baseUrl + "/listeners/stop";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processStopListeners(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processStopListeners(<any>response_);
                } catch (e) {
                    return <Observable<void>><any>_observableThrow(e);
                }
            } else
                return <Observable<void>><any>_observableThrow(response_);
        }));
    }

    protected processStopListeners(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob = 
            response instanceof HttpResponse ? response.body : 
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }};
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return _observableOf<void>(<any>null);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<void>(<any>null);
    }

    /**
     * Starts Message Queue Listeners
     * @return Success
     */
    openListeners(): Observable<void> {
        let url_ = this.baseUrl + "/listeners/start";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processOpenListeners(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processOpenListeners(<any>response_);
                } catch (e) {
                    return <Observable<void>><any>_observableThrow(e);
                }
            } else
                return <Observable<void>><any>_observableThrow(response_);
        }));
    }

    protected processOpenListeners(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob = 
            response instanceof HttpResponse ? response.body : 
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }};
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return _observableOf<void>(<any>null);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<void>(<any>null);
    }

    /**
     * Gets current status of Queue Listeners.
     * @return Success
     */
    getStatus(): Observable<void> {
        let url_ = this.baseUrl + "/listeners/status";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetStatus(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetStatus(<any>response_);
                } catch (e) {
                    return <Observable<void>><any>_observableThrow(e);
                }
            } else
                return <Observable<void>><any>_observableThrow(response_);
        }));
    }

    protected processGetStatus(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob = 
            response instanceof HttpResponse ? response.body : 
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }};
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return _observableOf<void>(<any>null);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<void>(<any>null);
    }

    /**
     * Provides current configuration information..
     * @return Success
     */
    ping(): Observable<void> {
        let url_ = this.baseUrl + "/ping";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processPing(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processPing(<any>response_);
                } catch (e) {
                    return <Observable<void>><any>_observableThrow(e);
                }
            } else
                return <Observable<void>><any>_observableThrow(response_);
        }));
    }

    protected processPing(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob = 
            response instanceof HttpResponse ? response.body : 
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }};
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return _observableOf<void>(<any>null);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<void>(<any>null);
    }

    /**
     * @return Success
     */
    getEvents(version: string): Observable<void> {
        let url_ = this.baseUrl + "/api/v{version}/Stream";
        if (version === undefined || version === null)
            throw new Error("The parameter 'version' must be defined.");
        url_ = url_.replace("{version}", encodeURIComponent("" + version)); 
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetEvents(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetEvents(<any>response_);
                } catch (e) {
                    return <Observable<void>><any>_observableThrow(e);
                }
            } else
                return <Observable<void>><any>_observableThrow(response_);
        }));
    }

    protected processGetEvents(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob = 
            response instanceof HttpResponse ? response.body : 
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }};
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return _observableOf<void>(<any>null);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<void>(<any>null);
    }

    /**
     * @param api_version (optional) 
     * @return Success
     */
    getByCatalogIdAndTaskIdLatest(catalogId: string, id: string, api_version: string | null | undefined): Observable<TaskModel> {
        let url_ = this.baseUrl + "/api/{catalogId}/tasks/{id}?";
        if (catalogId === undefined || catalogId === null)
            throw new Error("The parameter 'catalogId' must be defined.");
        url_ = url_.replace("{catalogId}", encodeURIComponent("" + catalogId)); 
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id)); 
        if (api_version !== undefined)
            url_ += "api-version=" + encodeURIComponent("" + api_version) + "&"; 
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetByCatalogIdAndTaskIdLatest(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetByCatalogIdAndTaskIdLatest(<any>response_);
                } catch (e) {
                    return <Observable<TaskModel>><any>_observableThrow(e);
                }
            } else
                return <Observable<TaskModel>><any>_observableThrow(response_);
        }));
    }

    protected processGetByCatalogIdAndTaskIdLatest(response: HttpResponseBase): Observable<TaskModel> {
        const status = response.status;
        const responseBlob = 
            response instanceof HttpResponse ? response.body : 
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }};
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = resultData200 ? TaskModel.fromJS(resultData200) : new TaskModel();
            return _observableOf(result200);
            }));
        } else if (status === 404) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("A server error occurred.", status, _responseText, _headers);
            }));
        } else if (status === 400) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("A server error occurred.", status, _responseText, _headers);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<TaskModel>(<any>null);
    }

    /**
     * @return Success
     */
    getTasksByCatalogId(catalogId: string, version: string): Observable<TaskModel[]> {
        let url_ = this.baseUrl + "/api/v{version}/{catalogId}/tasks";
        if (catalogId === undefined || catalogId === null)
            throw new Error("The parameter 'catalogId' must be defined.");
        url_ = url_.replace("{catalogId}", encodeURIComponent("" + catalogId)); 
        if (version === undefined || version === null)
            throw new Error("The parameter 'version' must be defined.");
        url_ = url_.replace("{version}", encodeURIComponent("" + version)); 
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetTasksByCatalogId(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetTasksByCatalogId(<any>response_);
                } catch (e) {
                    return <Observable<TaskModel[]>><any>_observableThrow(e);
                }
            } else
                return <Observable<TaskModel[]>><any>_observableThrow(response_);
        }));
    }

    protected processGetTasksByCatalogId(response: HttpResponseBase): Observable<TaskModel[]> {
        const status = response.status;
        const responseBlob = 
            response instanceof HttpResponse ? response.body : 
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }};
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (resultData200 && resultData200.constructor === Array) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(TaskModel.fromJS(item));
            }
            return _observableOf(result200);
            }));
        } else if (status === 404) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("A server error occurred.", status, _responseText, _headers);
            }));
        } else if (status === 400) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("A server error occurred.", status, _responseText, _headers);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<TaskModel[]>(<any>null);
    }

    /**
     * @return Success
     */
    getTaskStatuses(version: string): Observable<string[]> {
        let url_ = this.baseUrl + "/api/v{version}/taskStatuses";
        if (version === undefined || version === null)
            throw new Error("The parameter 'version' must be defined.");
        url_ = url_.replace("{version}", encodeURIComponent("" + version)); 
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetTaskStatuses(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetTaskStatuses(<any>response_);
                } catch (e) {
                    return <Observable<string[]>><any>_observableThrow(e);
                }
            } else
                return <Observable<string[]>><any>_observableThrow(response_);
        }));
    }

    protected processGetTaskStatuses(response: HttpResponseBase): Observable<string[]> {
        const status = response.status;
        const responseBlob = 
            response instanceof HttpResponse ? response.body : 
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }};
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (resultData200 && resultData200.constructor === Array) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(item);
            }
            return _observableOf(result200);
            }));
        } else if (status === 404) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("A server error occurred.", status, _responseText, _headers);
            }));
        } else if (status === 400) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("A server error occurred.", status, _responseText, _headers);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<string[]>(<any>null);
    }

    /**
     * @return Success
     */
    getTaskTypes(version: string): Observable<string[]> {
        let url_ = this.baseUrl + "/api/v{version}/taskTypes";
        if (version === undefined || version === null)
            throw new Error("The parameter 'version' must be defined.");
        url_ = url_.replace("{version}", encodeURIComponent("" + version)); 
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetTaskTypes(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetTaskTypes(<any>response_);
                } catch (e) {
                    return <Observable<string[]>><any>_observableThrow(e);
                }
            } else
                return <Observable<string[]>><any>_observableThrow(response_);
        }));
    }

    protected processGetTaskTypes(response: HttpResponseBase): Observable<string[]> {
        const status = response.status;
        const responseBlob = 
            response instanceof HttpResponse ? response.body : 
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }};
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (resultData200 && resultData200.constructor === Array) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(item);
            }
            return _observableOf(result200);
            }));
        } else if (status === 404) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("A server error occurred.", status, _responseText, _headers);
            }));
        } else if (status === 400) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("A server error occurred.", status, _responseText, _headers);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<string[]>(<any>null);
    }

    /**
     * @param catalogId (optional) 
     * @param filter (optional) 
     * @param skip (optional) 
     * @param take (optional) 
     * @param taskType (optional) 
     * @param taskStatus (optional) 
     * @param assignedTo (optional) 
     * @param sorting (optional) 
     * @param assignee (optional) 
     * @param submitterName (optional) 
     * @return Success
     */
    getTasks(catalogId: string | null | undefined, filter: string | null | undefined, skip: number | null | undefined, take: number | null | undefined, taskType: string[] | null | undefined, taskStatus: string[] | null | undefined, assignedTo: string[] | null | undefined, sorting: string | null | undefined, assignee: boolean | null | undefined, submitterName: string[] | null | undefined, version: string): Observable<GetTasksResponse> {
        let url_ = this.baseUrl + "/api/v{version}/tasks?";
        if (version === undefined || version === null)
            throw new Error("The parameter 'version' must be defined.");
        url_ = url_.replace("{version}", encodeURIComponent("" + version)); 
        if (catalogId !== undefined)
            url_ += "CatalogId=" + encodeURIComponent("" + catalogId) + "&"; 
        if (filter !== undefined)
            url_ += "Filter=" + encodeURIComponent("" + filter) + "&"; 
        if (skip !== undefined)
            url_ += "Skip=" + encodeURIComponent("" + skip) + "&"; 
        if (take !== undefined)
            url_ += "Take=" + encodeURIComponent("" + take) + "&"; 
        if (taskType !== undefined)
            taskType && taskType.forEach(item => { url_ += "TaskType=" + encodeURIComponent("" + item) + "&"; });
        if (taskStatus !== undefined)
            taskStatus && taskStatus.forEach(item => { url_ += "TaskStatus=" + encodeURIComponent("" + item) + "&"; });
        if (assignedTo !== undefined)
            assignedTo && assignedTo.forEach(item => { url_ += "AssignedTo=" + encodeURIComponent("" + item) + "&"; });
        if (sorting !== undefined)
            url_ += "Sorting=" + encodeURIComponent("" + sorting) + "&"; 
        if (assignee !== undefined)
            url_ += "Assignee=" + encodeURIComponent("" + assignee) + "&"; 
        if (submitterName !== undefined)
            submitterName && submitterName.forEach(item => { url_ += "SubmitterName=" + encodeURIComponent("" + item) + "&"; });
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetTasks(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetTasks(<any>response_);
                } catch (e) {
                    return <Observable<GetTasksResponse>><any>_observableThrow(e);
                }
            } else
                return <Observable<GetTasksResponse>><any>_observableThrow(response_);
        }));
    }

    protected processGetTasks(response: HttpResponseBase): Observable<GetTasksResponse> {
        const status = response.status;
        const responseBlob = 
            response instanceof HttpResponse ? response.body : 
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }};
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = resultData200 ? GetTasksResponse.fromJS(resultData200) : new GetTasksResponse();
            return _observableOf(result200);
            }));
        } else if (status === 404) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("A server error occurred.", status, _responseText, _headers);
            }));
        } else if (status === 400) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("A server error occurred.", status, _responseText, _headers);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<GetTasksResponse>(<any>null);
    }

    /**
     * @param request (optional) 
     * @return Success
     */
    createTask(request: CreateTask | null | undefined, version: string): Observable<void> {
        let url_ = this.baseUrl + "/api/v{version}/tasks";
        if (version === undefined || version === null)
            throw new Error("The parameter 'version' must be defined.");
        url_ = url_.replace("{version}", encodeURIComponent("" + version)); 
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(request);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json", 
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processCreateTask(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processCreateTask(<any>response_);
                } catch (e) {
                    return <Observable<void>><any>_observableThrow(e);
                }
            } else
                return <Observable<void>><any>_observableThrow(response_);
        }));
    }

    protected processCreateTask(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob = 
            response instanceof HttpResponse ? response.body : 
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }};
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return _observableOf<void>(<any>null);
            }));
        } else if (status === 404) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("A server error occurred.", status, _responseText, _headers);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<void>(<any>null);
    }

    /**
     * @param request (optional) 
     * @return Success
     */
    modifyTask(request: ModifyTask | null | undefined, version: string): Observable<void> {
        let url_ = this.baseUrl + "/api/v{version}/tasks";
        if (version === undefined || version === null)
            throw new Error("The parameter 'version' must be defined.");
        url_ = url_.replace("{version}", encodeURIComponent("" + version)); 
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(request);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json", 
            })
        };

        return this.http.request("patch", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processModifyTask(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processModifyTask(<any>response_);
                } catch (e) {
                    return <Observable<void>><any>_observableThrow(e);
                }
            } else
                return <Observable<void>><any>_observableThrow(response_);
        }));
    }

    protected processModifyTask(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob = 
            response instanceof HttpResponse ? response.body : 
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }};
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return _observableOf<void>(<any>null);
            }));
        } else if (status === 404) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("A server error occurred.", status, _responseText, _headers);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<void>(<any>null);
    }

    /**
     * @param status (optional) 
     * @param targetVersion (optional) 
     * @return Success
     */
    changeStatus(taskId: string, status: string | null | undefined, targetVersion: number | null | undefined, version: string): Observable<void> {
        let url_ = this.baseUrl + "/api/v{version}/tasks/{taskId}/status?";
        if (taskId === undefined || taskId === null)
            throw new Error("The parameter 'taskId' must be defined.");
        url_ = url_.replace("{taskId}", encodeURIComponent("" + taskId)); 
        if (version === undefined || version === null)
            throw new Error("The parameter 'version' must be defined.");
        url_ = url_.replace("{version}", encodeURIComponent("" + version)); 
        if (status !== undefined)
            url_ += "status=" + encodeURIComponent("" + status) + "&"; 
        if (targetVersion !== undefined)
            url_ += "targetVersion=" + encodeURIComponent("" + targetVersion) + "&"; 
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
            })
        };

        return this.http.request("patch", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processChangeStatus(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processChangeStatus(<any>response_);
                } catch (e) {
                    return <Observable<void>><any>_observableThrow(e);
                }
            } else
                return <Observable<void>><any>_observableThrow(response_);
        }));
    }

    protected processChangeStatus(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob = 
            response instanceof HttpResponse ? response.body : 
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }};
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return _observableOf<void>(<any>null);
            }));
        } else if (status === 404) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("A server error occurred.", status, _responseText, _headers);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<void>(<any>null);
    }

    /**
     * @param request (optional) 
     * @return Success
     */
    resolveTask(request: ResolveTask | null | undefined, version: string): Observable<void> {
        let url_ = this.baseUrl + "/api/v{version}/tasks/resolve";
        if (version === undefined || version === null)
            throw new Error("The parameter 'version' must be defined.");
        url_ = url_.replace("{version}", encodeURIComponent("" + version)); 
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(request);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json", 
            })
        };

        return this.http.request("patch", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processResolveTask(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processResolveTask(<any>response_);
                } catch (e) {
                    return <Observable<void>><any>_observableThrow(e);
                }
            } else
                return <Observable<void>><any>_observableThrow(response_);
        }));
    }

    protected processResolveTask(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob = 
            response instanceof HttpResponse ? response.body : 
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }};
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return _observableOf<void>(<any>null);
            }));
        } else if (status === 404) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("A server error occurred.", status, _responseText, _headers);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<void>(<any>null);
    }
}

export class TaskModel implements ITaskModel {
    id!: string | undefined;
    catalogId!: string | undefined;
    assignee!: string | undefined;
    taskState!: string | undefined;
    status!: string | undefined;
    title!: string | undefined;
    age!: number | undefined;
    taskType!: string | undefined;
    dueDate!: moment.Moment | undefined;
    followUp!: boolean | undefined;
    submitterId!: number | undefined;
    submitterName!: string | undefined;
    customerServiceRepresentative!: string | undefined;
    currentVersion!: number | undefined;

    constructor(data?: ITaskModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.id = data["id"];
            this.catalogId = data["catalogId"];
            this.assignee = data["assignee"];
            this.taskState = data["taskState"];
            this.status = data["status"];
            this.title = data["title"];
            this.age = data["age"];
            this.taskType = data["taskType"];
            this.dueDate = data["dueDate"] ? moment(data["dueDate"].toString()) : <any>undefined;
            this.followUp = data["followUp"];
            this.submitterId = data["submitterId"];
            this.submitterName = data["submitterName"];
            this.customerServiceRepresentative = data["customerServiceRepresentative"];
            this.currentVersion = data["currentVersion"];
        }
    }

    static fromJS(data: any): TaskModel {
        data = typeof data === 'object' ? data : {};
        let result = new TaskModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["catalogId"] = this.catalogId;
        data["assignee"] = this.assignee;
        data["taskState"] = this.taskState;
        data["status"] = this.status;
        data["title"] = this.title;
        data["age"] = this.age;
        data["taskType"] = this.taskType;
        data["dueDate"] = this.dueDate ? this.dueDate.toISOString() : <any>undefined;
        data["followUp"] = this.followUp;
        data["submitterId"] = this.submitterId;
        data["submitterName"] = this.submitterName;
        data["customerServiceRepresentative"] = this.customerServiceRepresentative;
        data["currentVersion"] = this.currentVersion;
        return data; 
    }
}

export interface ITaskModel {
    id: string | undefined;
    catalogId: string | undefined;
    assignee: string | undefined;
    taskState: string | undefined;
    status: string | undefined;
    title: string | undefined;
    age: number | undefined;
    taskType: string | undefined;
    dueDate: moment.Moment | undefined;
    followUp: boolean | undefined;
    submitterId: number | undefined;
    submitterName: string | undefined;
    customerServiceRepresentative: string | undefined;
    currentVersion: number | undefined;
}

export class GetTasksResponse implements IGetTasksResponse {
    data!: TaskModel[] | undefined;
    total!: number | undefined;

    constructor(data?: IGetTasksResponse) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            if (data["data"] && data["data"].constructor === Array) {
                this.data = [] as any;
                for (let item of data["data"])
                    this.data!.push(TaskModel.fromJS(item));
            }
            this.total = data["total"];
        }
    }

    static fromJS(data: any): GetTasksResponse {
        data = typeof data === 'object' ? data : {};
        let result = new GetTasksResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (this.data && this.data.constructor === Array) {
            data["data"] = [];
            for (let item of this.data)
                data["data"].push(item.toJSON());
        }
        data["total"] = this.total;
        return data; 
    }
}

export interface IGetTasksResponse {
    data: TaskModel[] | undefined;
    total: number | undefined;
}

export class CreateTask implements ICreateTask {
    aggregateId!: string | undefined;
    aggregateType!: string | undefined;
    targetVersion!: number | undefined;
    messageType!: string | undefined;
    messageClass!: string | undefined;
    classVersion!: number | undefined;
    messageId!: string | undefined;
    messageDate!: moment.Moment | undefined;
    correlationId!: string | undefined;
    priority!: CreateTaskPriority | undefined;
    traceData!: any | undefined;
    body!: any | undefined;

    constructor(data?: ICreateTask) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.aggregateId = data["aggregateId"];
            this.aggregateType = data["aggregateType"];
            this.targetVersion = data["targetVersion"];
            this.messageType = data["messageType"];
            this.messageClass = data["messageClass"];
            this.classVersion = data["classVersion"];
            this.messageId = data["messageId"];
            this.messageDate = data["messageDate"] ? moment(data["messageDate"].toString()) : <any>undefined;
            this.correlationId = data["correlationId"];
            this.priority = data["priority"];
            this.traceData = data["traceData"];
            this.body = data["body"];
        }
    }

    static fromJS(data: any): CreateTask {
        data = typeof data === 'object' ? data : {};
        let result = new CreateTask();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["aggregateId"] = this.aggregateId;
        data["aggregateType"] = this.aggregateType;
        data["targetVersion"] = this.targetVersion;
        data["messageType"] = this.messageType;
        data["messageClass"] = this.messageClass;
        data["classVersion"] = this.classVersion;
        data["messageId"] = this.messageId;
        data["messageDate"] = this.messageDate ? this.messageDate.toISOString() : <any>undefined;
        data["correlationId"] = this.correlationId;
        data["priority"] = this.priority;
        data["traceData"] = this.traceData;
        data["body"] = this.body;
        return data; 
    }
}

export interface ICreateTask {
    aggregateId: string | undefined;
    aggregateType: string | undefined;
    targetVersion: number | undefined;
    messageType: string | undefined;
    messageClass: string | undefined;
    classVersion: number | undefined;
    messageId: string | undefined;
    messageDate: moment.Moment | undefined;
    correlationId: string | undefined;
    priority: CreateTaskPriority | undefined;
    traceData: any | undefined;
    body: any | undefined;
}

export class ModifyTask implements IModifyTask {
    aggregateId!: string | undefined;
    aggregateType!: string | undefined;
    targetVersion!: number | undefined;
    messageType!: string | undefined;
    messageClass!: string | undefined;
    classVersion!: number | undefined;
    messageId!: string | undefined;
    messageDate!: moment.Moment | undefined;
    correlationId!: string | undefined;
    priority!: ModifyTaskPriority | undefined;
    traceData!: any | undefined;
    body!: any | undefined;

    constructor(data?: IModifyTask) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.aggregateId = data["aggregateId"];
            this.aggregateType = data["aggregateType"];
            this.targetVersion = data["targetVersion"];
            this.messageType = data["messageType"];
            this.messageClass = data["messageClass"];
            this.classVersion = data["classVersion"];
            this.messageId = data["messageId"];
            this.messageDate = data["messageDate"] ? moment(data["messageDate"].toString()) : <any>undefined;
            this.correlationId = data["correlationId"];
            this.priority = data["priority"];
            this.traceData = data["traceData"];
            this.body = data["body"];
        }
    }

    static fromJS(data: any): ModifyTask {
        data = typeof data === 'object' ? data : {};
        let result = new ModifyTask();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["aggregateId"] = this.aggregateId;
        data["aggregateType"] = this.aggregateType;
        data["targetVersion"] = this.targetVersion;
        data["messageType"] = this.messageType;
        data["messageClass"] = this.messageClass;
        data["classVersion"] = this.classVersion;
        data["messageId"] = this.messageId;
        data["messageDate"] = this.messageDate ? this.messageDate.toISOString() : <any>undefined;
        data["correlationId"] = this.correlationId;
        data["priority"] = this.priority;
        data["traceData"] = this.traceData;
        data["body"] = this.body;
        return data; 
    }
}

export interface IModifyTask {
    aggregateId: string | undefined;
    aggregateType: string | undefined;
    targetVersion: number | undefined;
    messageType: string | undefined;
    messageClass: string | undefined;
    classVersion: number | undefined;
    messageId: string | undefined;
    messageDate: moment.Moment | undefined;
    correlationId: string | undefined;
    priority: ModifyTaskPriority | undefined;
    traceData: any | undefined;
    body: any | undefined;
}

export class ResolveTask implements IResolveTask {
    aggregateId!: string | undefined;
    aggregateType!: string | undefined;
    targetVersion!: number | undefined;
    messageType!: string | undefined;
    messageClass!: string | undefined;
    classVersion!: number | undefined;
    messageId!: string | undefined;
    messageDate!: moment.Moment | undefined;
    correlationId!: string | undefined;
    priority!: ResolveTaskPriority | undefined;
    traceData!: any | undefined;
    body!: any | undefined;

    constructor(data?: IResolveTask) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.aggregateId = data["aggregateId"];
            this.aggregateType = data["aggregateType"];
            this.targetVersion = data["targetVersion"];
            this.messageType = data["messageType"];
            this.messageClass = data["messageClass"];
            this.classVersion = data["classVersion"];
            this.messageId = data["messageId"];
            this.messageDate = data["messageDate"] ? moment(data["messageDate"].toString()) : <any>undefined;
            this.correlationId = data["correlationId"];
            this.priority = data["priority"];
            this.traceData = data["traceData"];
            this.body = data["body"];
        }
    }

    static fromJS(data: any): ResolveTask {
        data = typeof data === 'object' ? data : {};
        let result = new ResolveTask();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["aggregateId"] = this.aggregateId;
        data["aggregateType"] = this.aggregateType;
        data["targetVersion"] = this.targetVersion;
        data["messageType"] = this.messageType;
        data["messageClass"] = this.messageClass;
        data["classVersion"] = this.classVersion;
        data["messageId"] = this.messageId;
        data["messageDate"] = this.messageDate ? this.messageDate.toISOString() : <any>undefined;
        data["correlationId"] = this.correlationId;
        data["priority"] = this.priority;
        data["traceData"] = this.traceData;
        data["body"] = this.body;
        return data; 
    }
}

export interface IResolveTask {
    aggregateId: string | undefined;
    aggregateType: string | undefined;
    targetVersion: number | undefined;
    messageType: string | undefined;
    messageClass: string | undefined;
    classVersion: number | undefined;
    messageId: string | undefined;
    messageDate: moment.Moment | undefined;
    correlationId: string | undefined;
    priority: ResolveTaskPriority | undefined;
    traceData: any | undefined;
    body: any | undefined;
}

export enum CreateTaskPriority {
    _0 = 0, 
    _2 = 2, 
    _4 = 4, 
    _6 = 6, 
}

export enum ModifyTaskPriority {
    _0 = 0, 
    _2 = 2, 
    _4 = 4, 
    _6 = 6, 
}

export enum ResolveTaskPriority {
    _0 = 0, 
    _2 = 2, 
    _4 = 4, 
    _6 = 6, 
}

export class SwaggerException extends Error {
    message: string;
    status: number; 
    response: string; 
    headers: { [key: string]: any; };
    result: any; 

    constructor(message: string, status: number, response: string, headers: { [key: string]: any; }, result: any) {
        super();

        this.message = message;
        this.status = status;
        this.response = response;
        this.headers = headers;
        this.result = result;
    }

    protected isSwaggerException = true;

    static isSwaggerException(obj: any): obj is SwaggerException {
        return obj.isSwaggerException === true;
    }
}

function throwException(message: string, status: number, response: string, headers: { [key: string]: any; }, result?: any): Observable<any> {
    if(result !== null && result !== undefined)
        return _observableThrow(result);
    else
        return _observableThrow(new SwaggerException(message, status, response, headers, null));
}

function blobToText(blob: any): Observable<string> {
    return new Observable<string>((observer: any) => {
        if (!blob) {
            observer.next("");
            observer.complete();
        } else {
            let reader = new FileReader(); 
            reader.onload = event => { 
                observer.next((<any>event.target).result);
                observer.complete();
            };
            reader.readAsText(blob); 
        }
    });
}
